export default __webpack_public_path__ + "static/media/NoRacesMascot.2cd44668.png";